import {useAppContext} from "../../context/Context";
import {ACTION} from "../../context/actionTypes";
import {useEffect, useState} from "react";
import api from "../../utils/api";
import {setBottomBarError} from "../../utils/Functions";
import useConfiguration from "../../components/administration/manageTechnical/inference/useConfiguration";

export default function useUpdateCompanyRestrictionsModal({id: companyId, reload}) {
    const [, dispatch] = useAppContext();
    const [{configuration}] = useConfiguration();
    const [isCompanyRestrictionsLoading, setIsCompanyRestrictionsLoading] = useState(true);
    const [companyQuestionsEnabled, setCompanyQuestionsEnabled] = useState<boolean | null>(null);
    const [companyDocumentsUploadEnabled, setCompanyDocumentsUploadEnabled] = useState<boolean | null>(null);

    useEffect(() => {
        async function fetchCompanyRestrictions() {
            try {
                const response = await api.get(`/company/${companyId}/restrictions`);
                setCompanyQuestionsEnabled(response.data.questions_enabled);
                setCompanyDocumentsUploadEnabled(response.data.documents_upload_enabled);
                setIsCompanyRestrictionsLoading(false);
            } catch (e) {
                setBottomBarError(dispatch, e);
            }
        }

        fetchCompanyRestrictions().catch(console.error);
    }, [companyId, dispatch]);

    function toggleMe() {
        dispatch({type: ACTION.SET_GENERIC_MODAL, payload: null});
    }

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            await api.put(`/company/${companyId}/restrictions`, {
                questions_enabled: companyQuestionsEnabled,
                documents_upload_enabled: companyDocumentsUploadEnabled,
            });
            toggleMe();
            reload();
        } catch (e) {
            setBottomBarError(dispatch, e);
        }
    }


    return [
        {
            configuration,
            isCompanyRestrictionsLoading,
            companyQuestionsEnabled,
            companyDocumentsUploadEnabled,
        },
        {toggleMe, setCompanyQuestionsEnabled, setCompanyDocumentsUploadEnabled, handleSubmit},
    ];
}